// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"9edf4c6f","498":"12698ef4","513":"856e1348","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};